/* eslint-disable no-underscore-dangle */
export interface ErrorInfo {
  objectName?: string;
  field?: string;
  message?: string;
}

export class FormError extends Error {
  private _fieldErrors: ErrorInfo[];

  constructor(message: string, fieldErrors: ErrorInfo[]) {
    super(message);
    Object.setPrototypeOf(this, FormError.prototype);
    this._fieldErrors = fieldErrors;
  }

  get fieldErrors(): ErrorInfo[] {
    return this._fieldErrors;
  }

  set fieldErrors(value: ErrorInfo[]) {
    this._fieldErrors = value;
  }
}
